import _find from 'lodash/find';
import logger from '../../../utils/logger';
import symplEan13Format from './skeletons/symplEan13.json';
import symplFormat from './skeletons/sympl.json';
import symplFormatPickup from './skeletons/symplPickup.json';
import symplEan13CarrierPickupPoint from './skeletons/symplEan13CarrierPickupPoint.json';
import symplEan13FormatPickup from './skeletons/symplEan13PickupPoint.json';
import symplEan13FormatPickupWithoutComma from './skeletons/symplEan13PickupPointWithoutComma.json';
import kumikoFormat from './skeletons/kumiko.json';
import saeve from './skeletons/saeve.json';
import prs from './skeletons/prs.json';
import verreImage from './skeletons/verreImage.json';
import monDoigtDansTaRue from './skeletons/monDoigtDansTaRue.json';
import squarespace from './skeletons/squarespace.json';
import shopify from './skeletons/shopify.json';
import shopify2 from './skeletons/shopify2.json';

/**
 * @description Liste des squelettes ( format )
 */
const skeletons = [
  symplFormat,
  symplEan13Format,
  kumikoFormat,
  saeve,
  verreImage,
  prs,
  monDoigtDansTaRue,
  symplFormatPickup,
  symplEan13CarrierPickupPoint,
  symplEan13FormatPickup,
  symplEan13FormatPickupWithoutComma,
  squarespace,
  shopify,
  shopify2
];

/**
 * @function getSkeleton
 * @description Récupére l'objet json qui correspond au squelette ( format )
 * du fichier
 * @param {array} acceptedFiles - Fichiers uploader
 */
const getSkeleton = jsonFile => {
  const jsonFileKeys = Object.keys(jsonFile[0])
    .sort()
    .filter(value => !/^.{2} Tax$/.test(value));

  let skeletonValues;

  const currentSkeleton = _find(skeletons, skeleton => {
    skeletonValues = Object.values(skeleton).sort();
    return (
      JSON.stringify(jsonFileKeys).replace(/\s/g, '') ===
      JSON.stringify(skeletonValues).replace(/\s/g, '')
    );
  });
  if (currentSkeleton) {
    return currentSkeleton;
  }
  logger('No skeleton found for this object');
  logger(jsonFileKeys);
  logger('No skeleton found for this object');
  return currentSkeleton;
};

export default getSkeleton;
